/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { $, fd } from '../theme';
import Ic from '../Icon';
import { printDocument, generateReceiptHTML } from './PDFExport';

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export default function Receipts({ pays = [], isLL, activeTenant, tenants = [], leases = [] }) {
  const [selTenant, setSelTenant] = useState('all');
  const [selMonth, setSelMonth]   = useState('all');
  const [showReceipt, setShowReceipt] = useState(null);

  const tenantName = tid => {
    const t = tenants.find(t => t.id === tid);
    return t ? (t.full_name || t.name) : 'Unknown';
  };
  const tenantUnit = tid => {
    const t = tenants.find(t => t.id === tid);
    return t ? (t.unit || t.u || '—') : '—';
  };

  const visible = pays.filter(p => {
    if (!isLL && activeTenant && (p.tenant_id || p.tid) !== activeTenant.id) return false;
    if (isLL && selTenant !== 'all' && (p.tenant_id || p.tid) !== parseInt(selTenant)) return false;
    if (selMonth !== 'all') {
      const d = p.payment_date || p.date || '';
      if (!d.startsWith(selMonth)) return false;
    }
    return (p.status || p.st) === 'paid';
  });

  const months = [...new Set(pays.map(p => (p.payment_date || p.date || '').slice(0,7)))].sort().reverse();

  const total = visible.reduce((s, p) => s + (p.amount || p.amt || 0), 0);

  return (
    <div>
      {/* Stats */}
      <div className="g2">
        <div className="st">
          <div className="stb" style={{background:'linear-gradient(90deg,#16a34a,#4ade80)'}}/>
          <small>Receipts Shown</small>
          <div className="stv">{visible.length}</div>
          <div className="sts">filtered results</div>
        </div>
        <div className="st">
          <div className="stb" style={{background:'linear-gradient(90deg,#58a6ff,#79c0ff)'}}/>
          <small>Total Collected</small>
          <div className="stv">{$(total)}</div>
          <div className="sts">from {visible.length} payments</div>
        </div>
      </div>

      <div className="card">
        <div className="card-hd"><h3>Rent Receipts</h3></div>

        {/* Filters */}
        <div style={{display:'flex',gap:10,marginBottom:14,flexWrap:'wrap'}}>
          {isLL && (
            <select
              style={{background:'#21262d',border:'1px solid #2d333b',borderRadius:8,padding:'8px 12px',color:'#f5f0e8',fontSize:12,fontFamily:'Outfit,sans-serif',cursor:'pointer'}}
              value={selTenant}
              onChange={e => setSelTenant(e.target.value)}
            >
              <option value="all">All Tenants</option>
              {tenants.map(t => <option key={t.id} value={t.id}>{t.full_name||t.name}</option>)}
            </select>
          )}
          <select
            style={{background:'#21262d',border:'1px solid #2d333b',borderRadius:8,padding:'8px 12px',color:'#f5f0e8',fontSize:12,fontFamily:'Outfit,sans-serif',cursor:'pointer'}}
            value={selMonth}
            onChange={e => setSelMonth(e.target.value)}
          >
            <option value="all">All Months</option>
            {months.map(m => {
              const [yr, mo] = m.split('-');
              return <option key={m} value={m}>{MONTHS[parseInt(mo)-1]} {yr}</option>;
            })}
          </select>
        </div>

        {visible.length === 0 ? (
          <div style={{textAlign:'center',padding:'40px 20px',color:'#484f58'}}>
            <Ic n="receipt" s={36} c="#484f58"/>
            <div style={{marginTop:12,fontSize:13}}>No receipts found for this filter</div>
          </div>
        ) : (
          <div className="tw">
            <table>
              <thead>
                <tr>
                  {isLL && <th>Tenant</th>}
                  <th>Reference</th>
                  <th>Period</th>
                  <th>Method</th>
                  <th>Date</th>
                  <th style={{textAlign:'right'}}>Amount</th>
                  <th/>
                </tr>
              </thead>
              <tbody>
                {visible.map(p => (
                  <tr key={p.id}>
                    {isLL && (
                      <td>
                        <div className="tc">
                          <div className="av" style={{width:28,height:28,fontSize:10}}>
                            {tenantName(p.tenant_id||p.tid).split(' ').map(w=>w[0]).join('').slice(0,2).toUpperCase()}
                          </div>
                          <div>
                            <div style={{fontSize:12,fontWeight:600,color:'#fff'}}>{tenantName(p.tenant_id||p.tid)}</div>
                            <div style={{fontSize:11,color:'#484f58'}}>Unit {tenantUnit(p.tenant_id||p.tid)}</div>
                          </div>
                        </div>
                      </td>
                    )}
                    <td style={{fontFamily:'monospace',color:'#58a6ff',fontSize:12}}>{p.reference_no||p.ref||'—'}</td>
                    <td style={{color:'#8b949e',fontSize:12}}>{p.mth_name || (p.payment_date||p.date||'').slice(0,7)}</td>
                    <td><span className="b bbl" style={{fontSize:10,padding:'1px 7px'}}>{p.method||p.mth||'—'}</span></td>
                    <td style={{color:'#8b949e',fontSize:12}}>{fd(p.payment_date||p.date)}</td>
                    <td style={{textAlign:'right',fontWeight:700,color:'#22c55e'}}>{$(p.amount||p.amt)}</td>
                    <td style={{display:'flex',gap:5}}>
                      <button className="btn btn-gh" style={{padding:'4px 10px',fontSize:11}} onClick={() => setShowReceipt(p)}>
                        <Ic n="doc" s={12}/> View
                      </button>
                      <button className="btn btn-d" style={{padding:'4px 10px',fontSize:11}}
                        onClick={() => printDocument(generateReceiptHTML(p, tenantName(p.tenant_id||p.tid), `Unit ${tenantUnit(p.tenant_id||p.tid)}`))}>
                        <Ic n="dl" s={12}/> PDF
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Receipt Modal */}
      {showReceipt && (
        <div className="mov" onClick={e => e.target === e.currentTarget && setShowReceipt(null)}>
          <div className="modal">
            <div className="mhd">
              <h2>Rent Receipt</h2>
              <button className="btn btn-gh" style={{padding:'5px 9px'}} onClick={() => setShowReceipt(null)}><Ic n="x" s={15}/></button>
            </div>
            <div className="mbdy">
              <div style={{background:'#21262d',borderRadius:10,padding:'20px',marginBottom:16}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:16}}>
                  <div>
                    <div style={{fontFamily:"'Playfair Display',serif",fontSize:20,fontWeight:900,color:'#fff'}}>RentLord</div>
                    <div style={{fontSize:11,color:'#484f58',marginTop:2}}>Rent Receipt</div>
                  </div>
                  <span className="b bg">PAID</span>
                </div>
                {[
                  ['Receipt #', showReceipt.reference_no || showReceipt.ref || '—'],
                  ['Tenant', tenantName(showReceipt.tenant_id || showReceipt.tid)],
                  ['Unit', `Unit ${tenantUnit(showReceipt.tenant_id || showReceipt.tid)}`],
                  ['Period', showReceipt.mth_name || (showReceipt.payment_date||showReceipt.date||'').slice(0,7)],
                  ['Payment Date', fd(showReceipt.payment_date || showReceipt.date)],
                  ['Method', showReceipt.method || showReceipt.mth || '—'],
                ].map(([label, val]) => (
                  <div key={label} className="row" style={{padding:'8px 0'}}>
                    <span className="rl">{label}</span>
                    <span style={{color:'#f5f0e8',fontSize:13,fontWeight:500}}>{val}</span>
                  </div>
                ))}
                <div style={{marginTop:12,paddingTop:12,borderTop:'1px solid #2d333b',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                  <span style={{fontWeight:700,color:'#fff',fontSize:14}}>Amount Paid</span>
                  <span style={{fontFamily:"'Playfair Display',serif",fontSize:22,fontWeight:900,color:'#4ade80'}}>
                    {$(showReceipt.amount || showReceipt.amt)}
                  </span>
                </div>
              </div>
              <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
                <button className="btn btn-gh" onClick={() => setShowReceipt(null)}>Close</button>
                <button className="btn btn-g" onClick={() => printDocument(generateReceiptHTML(showReceipt, tenantName(showReceipt.tenant_id||showReceipt.tid), `Unit ${tenantUnit(showReceipt.tenant_id||showReceipt.tid)}`))}>
                  <Ic n="dl" s={14}/> Download PDF
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
